// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"55f352c0","723":"84a9bf05"}[chunkId] + ".chunk.js";
};